// extracted by mini-css-extract-plugin
export default {"base":"DialogInformation_base__wrL8J","content":"DialogInformation_content__4+4rq","hidden":"DialogInformation_hidden__CByUv"};